module.exports = __webpack_public_path__ + "img/dfclub-logo.dd184367.svg";